<template lang="html">
  <img v-if="user && user.avatar" class="user-avatar"  :src="avaSrc" />
  <div v-else-if="user" class="user-avatar">{{ user.firstName && user.firstName[0] }}{{ user.lastName && user.lastName[0] }}</div>
</template>

<script>
import Avatars from '@/enums/avatars'

export default {
  name: 'Avatar',
  props: {
    /**
     * Объект пользователя
     * user { avatar: String, count_new_message: Number, firstName: String, lastName: String }
     */
    user: Object,

    imgHost: {
      type: String,
      default: ''
    }
  },
  computed: {
    isEmoji () {
      return !!Avatars[this.user.avatar]
    },
    avaSrc () {
      return this.isEmoji ? Avatars.icon(Avatars[this.user.avatar]) : `${this.imgHost}${this.user.avatar}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-avatar {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    overflow: hidden;
    object-fit: cover;

    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;

    background-color: #e8edff;
    line-height: 1.5;
    letter-spacing: 0.2px;
    font-size: 18px;
  }
</style>
